/**
 * serviceProductGroups - Filtro de categoria/subcategoria do seletor "Adicionar serviço"
 * (desktop e app do prestador).
 *
 * RELEASE: 2026-10-17 v1.1.0 - Troca agrupamento por filtro: lista de categorias + filtro de serviços.
 * RELEASE: 2026-10-17 v1.0.0 - Versão inicial.
 */

export interface ServiceProductOption {
  id: string;
  name: string;
  sku: string | null;
  category_name?: string | null;
  parent_category_name?: string | null;
  category_sort?: number | null;
}

export const SEM_CATEGORIA = '__sem__';
const SEP = ' › ';

/** Chaves de categoria a que o serviço pertence: pai e "pai › sub" (ou só a categoria). */
function chavesDo(p: ServiceProductOption): string[] {
  if (p.parent_category_name && p.category_name) return [p.parent_category_name, `${p.parent_category_name}${SEP}${p.category_name}`];
  const c = p.category_name || p.parent_category_name;
  return c ? [c] : [SEM_CATEGORIA];
}

/** Opções do campo Categoria: ordem cadastrada, pai antes das subcategorias, "Sem categoria" por último. */
export function opcoesCategoria(products: ServiceProductOption[]) {
  const mapa = new Map<string, number>();
  for (const p of products) for (const k of chavesDo(p)) {
    const s = p.category_sort ?? 9999;
    mapa.set(k, Math.min(mapa.get(k) ?? 9999, s));
  }
  return [...mapa.entries()]
    .sort(([a, sa], [b, sb]) => {
      if (a === SEM_CATEGORIA) return 1;
      if (b === SEM_CATEGORIA) return -1;
      return sa - sb || a.localeCompare(b, 'pt-BR');
    })
    .map(([k]) => ({ value: k, label: k === SEM_CATEGORIA ? 'Sem categoria' : k }));
}

/** Serviços da categoria escolhida (pai inclui subcategorias); sem filtro devolve todos. */
export function filtrarPorCategoria(products: ServiceProductOption[], categoria: string | null) {
  if (!categoria) return products;
  return products.filter((p) => chavesDo(p).includes(categoria));
}
